import React from 'react'
import * as ProductIcons from 'components/ProductIcons'
import * as NotProductIcons from 'components/NotProductIcons'
import { prepareData } from 'utils/googleData'

export default function Approach(props) {
  const {
    enable,
    title,
    subtitle,
    features,
    direction,
  } = prepareData({ props })

    if ((enable === false || enable?.toLowerCase?.() === 'false') && !process.env.RENDER_DISABLED_COMPONENTS) {
    return <></>
  }

  return (
    <section dir={direction} className="py-24 px-5 bg-gray-50 dark:bg-[#0B1C39]">
      <div className="max-w-7xl mx-auto">
        {/* Title Section */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold mb-6 text-gray-900 dark:text-white"
            dangerouslySetInnerHTML={{ __html: title }}>
          </h2>
          <p className="text-lg lg:text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
            {subtitle}
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features?.map((feature, index) => {
            const { icon, name, description, style = '' } = feature
            const Icon = NotProductIcons[icon] || ProductIcons[icon]

            return (
              <div
                key={index}
                className="bg-white dark:bg-[#1B3154] rounded-2xl p-8 text-center group hover:shadow-lg transition-all duration-300"
              >
                {icon && (
                  <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#E6F4FF] dark:bg-[#2C4268] mb-6 group-hover:bg-blue-100 dark:group-hover:bg-[#2C4268]/80 transition-colors duration-300 dark:ring-4 dark:ring-[#1B3154]/50">
                    <Icon className={`w-8 h-8 text-[#4BB3FD] ${style}`} />
                  </div>
                )}
                <h3 className="text-xl font-bold mb-4 text-gray-900 dark:text-white">
                  {name}
                </h3>
                <p className="text-gray-600 dark:text-[#E5E7EB] leading-relaxed">
                  {description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  )
}
